import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInsights } from "../../constants";
import { PriceInsightOrdersListItem } from "../../insights.types";

export const requestPriceInsightOrders = async (
  params: GetListRequestParams
): Promise<GetListResponse<PriceInsightOrdersListItem>> => {
  return await instance.get(ApiRoutesInsights.PriceInsightOrders, {
    params
  });
};
